<template>
    <div :class="['tab-pane', 'fade', active ? 'show active' : '']" id="system" role="tabpanel" aria-labelledby="system-tab">
        <div class="card card-settings">
            <div class="card-body col-md-6 m-auto py-5">
                <form class="needs-validation" @submit.prevent="updateSystem">
                    <div class="mb-3">
                        <label for="algorithmSelect">Algorithm for call allocation</label>
                        <select class="custom-select d-block w-100" id="algorithmSelect" required @change="selectAlgorithm">
                            <option
                                v-for="alg in algorithms"
                                :key="alg.value"
                                :value="alg.value"
                                :selected="system.algorithm == alg.value"
                            >
                                {{ alg.label }}
                            </option>
                        </select>
                    </div>

                    <div class="mb-3">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="paymentCheck" v-model="paymentEnabled">
                            <label class="custom-control-label" for="paymentCheck">Enable Payments</label>
                        </div>

                        <div class="custom-control custom-checkbox custom-control-inline">
                            <input type="checkbox" class="custom-control-input" id="crmCheck" v-model="crmEnabled">
                            <label class="custom-control-label" for="crmCheck">Enable CRM</label>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="adminPassword">Admin Password</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <font-awesome-icon :icon="['fas', 'key']" class="input-group-text" size="xs" />
                            </div>
                            <input type="password" class="form-control" id="adminPassword" v-model="adminPassword" required>
                        </div>
                    </div>
                    <div v-if="error" class="alert alert-danger alert-dismissible fade show" role="alert">
                        {{ error }}
                    </div>
                    <div v-if="success" class="alert alert-success alert-dismissible fade show" role="alert">
                        {{ success }}
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearSuccessMessage">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div v-if="submited" class="text-center">
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <button v-else class="btn btn-primary btn-lg btn-block mt-4" type="submit" :disabled="!formIsValid">Save</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'SystemSettings',
    props: ['active'],
    created() {
        this.algorithm = this.system.algorithm;
        this.paymentEnabled = this.system.paymentEnabled;
        this.crmEnabled = this.system.crmEnabled;
    },
    data: () => ({
        adminPassword: '',
        algorithm: '',
        paymentEnabled: false,
        crmEnabled: false,
        algorithms: [
            {label: 'Last Agent', value: 'last'},
            {label: 'All', value: 'all'},
            {label: 'Least Load', value: 'load'}
        ],
        submited: false,
        success: undefined,
    }),
    computed: {
        ...mapGetters([
            'error',
            'system'
        ]),
        formIsValid() {
            return this.adminPassword.trim().length > 0;
        },
    },
    methods: {
        updateSystem() {
            this.submited = true;
            this.$store.dispatch('updateSystem', {'algorithm': this.algorithm, 'crmEnabled': this.crmEnabled, 'paymentEnabled': this.paymentEnabled, 'password': this.adminPassword})
            .then(() => {
                if (!this.error) {
                    this.success = 'System settings changed successfully';
                    this.adminPassword = '';
                }
                this.submited = false
            });
        },
        selectAlgorithm(evt) {
            this.algorithm = evt.target.value;
        },
        clearSuccessMessage() {
            this.success = undefined;
        }
    }
}
</script>